var map = {
	"./EVO.png": 1592,
	"./Path 20295.png": 1593,
	"./ab-img.webp": 1594,
	"./ab-title-cn.webp": 1595,
	"./ab-title-en.webp": 1596,
	"./ag-img.png": 1597,
	"./ag-img.webp": 1598,
	"./ag-title-cn.webp": 1599,
	"./ag-title-en.webp": 1600,
	"./chess-img.webp": 1601,
	"./coin-img.webp": 1602,
	"./content-img.webp": 1603,
	"./dg-img.webp": 1604,
	"./dg-title-cn.webp": 1605,
	"./dg-title-en.webp": 1606,
	"./diamond-img.webp": 1607,
	"./dice-coin.webp": 1608,
	"./ea-img.webp": 1609,
	"./ea-title-cn.webp": 1610,
	"./ea-title-en.webp": 1611,
	"./evo-img.webp": 1612,
	"./evo-title-cn.webp": 1613,
	"./evo-title-en.webp": 1614,
	"./golddice-img.webp": 1615,
	"./gp-img.webp": 1616,
	"./gp-title-cn.webp": 1617,
	"./gp-title-en.webp": 1618,
	"./heart-coin-img.webp": 1619,
	"./lc-bg.webp": 1620,
	"./mg-img.webp": 1621,
	"./mg-title-cn.webp": 1622,
	"./mg-title-en.webp": 1623,
	"./pp-img.webp": 1624,
	"./pp-title-cn.webp": 1625,
	"./pp-title-en.webp": 1626,
	"./pt-img.webp": 1627,
	"./pt-title-cn.webp": 1628,
	"./pt-title-en.webp": 1629,
	"./sa-img.webp": 1630,
	"./sa-title-cn.webp": 1631,
	"./sa-title-en.webp": 1632,
	"./sbo-img.webp": 1633,
	"./sbo-title-cn.webp": 1634,
	"./sbo-title-en.webp": 1635,
	"./spade-img.webp": 1636,
	"./white-spade-img.webp": 1637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1591;